import { CSSProperties } from 'react';
import { statusColors } from '../constants';
import { ProjectStatus } from '../enums/projectStatus';

export const getProjectStatusStyle = (status: ProjectStatus): CSSProperties => {
  return {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: statusColors[status],
    padding: '8px',
    borderRadius: '3px',
    color: '#4A4A4A'
  };
};
